<script>
import {AxisNames, Orientations, ScaleTypes} from '@/components/plots/enums'
import CandelaComponent from '@/components/CandelaComponent'
import {bars} from '@/components/plots/atoms'

export default {
  computed: {
    band_scale() {
      if(this.axis_y && this.axis_x) {
        return this.is_horizontal ? this.axis_y.scale : this.axis_x.scale
      }
      return null
    },
    cont_scale() {
      if(this.axis_x && this.axis_y) {
        return this.is_horizontal ? this.axis_x.scale : this.axis_y.scale
      }
      return null
    },
    bars() {
      if(this.band_scale && this.cont_scale) {
        return bars(this.x, this.y, this.band_scale, this.cont_scale, this.orientation)
      }
      return []
    },
    is_horizontal() { return this.orientation === Orientations.Horizontal }
  },
  data() {
    return {
      AxisNames,
      ScaleTypes,
      axis_x: null,
      axis_y: null,
      plot_key: 0
    }
  },
  methods: {
    update(axes) {
      this.axis_x = this.is_horizontal ? axes.x2 : axes.x
      this.axis_y = axes.y
    }
  },
  name: 'candela-bar-chart',
  extends: CandelaComponent,
  props: {
    orientation: {type: String, default: () => Orientations.Horizontal},
    x: {type: Object, default: () => ({})},
    y: {type: Object, default: () => ({})}
  },
  watch: {
    orientation() {
      // When the orientation changes,
      // we need to completely re-build the plot.
      // This key is used as the "key" param of the plot element below
      // When it changes, the element is refreshed
      this.plot_key++
    }
  }
}
</script>

<template>
<div class='candela-component'>
  <candela-plot :id='id' @update='update' :frame='frame'
    :key='`plot-key-${plot_key}`'>
    <candela-axis v-if='is_horizontal' :slot='AxisNames.X2' v-bind='y'/>
    <candela-axis v-else :slot='AxisNames.X' v-bind='x'
      :scale_type='ScaleTypes.Band'/>

    <candela-axis v-if='is_horizontal' :slot='AxisNames.Y' v-bind='x'
      :scale_type='ScaleTypes.Band'/>
    <candela-axis v-else :slot='AxisNames.Y' v-bind='y'/>

    <g slot='content'>
      <candela-grid-lines v-if='settings.show_grid.value'
        :axis_x='axis_x' :axis_y='axis_y'/>

      <rect v-for='(bar, i) in bars' :key='i'
        :fill='settings.plot_colors.value'
        :x='bar.x' :y='bar.y' :width='bar.width'
        :height='Math.floor(bar.height)'/>
    </g>
  </candela-plot>
</div>
</template>
